module.exports = __webpack_public_path__ + "img/ja.1f905d23.svg";